<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <template v-if="!ClientContractID || !ClientContractID.id">
            <div class="d-flex align-items-center justify-content-center" style="height: calc(100vh - 57px);">
                <h2 class="text-danger">Please choose a contract to load the calendar.</h2>
            </div>
        </template>
    	<div v-else class="boxShadow setBorderRadius heig-frame-equipment-group">
      		<b-row no-gutters>
        		<b-col md="12" class="heig-frame-child">
        			<gofix-card>
                        <b-row>
                            <b-col md="12">
                                <b-row>
                                    <b-col md="2">
                                        &nbsp;
                                    </b-col>
                                </b-row>
                                <b-row align-v="center">
                                    <b-col md="3">
                                        <gofix-form-dropdown
                                            label="Maint. Program"
                                            vLabel="description_one"
                                            class="mb-0"
                                            :class="[{'run-loading small-loading': loading.maintenance} ]"
                                            :clearable="false"
                                            :filterable="false" 
                                            :options="options.maints"
                                            v-model="filters.maintenance"
                                            @search="searchMaintProgram"
                                            :placeholder="'Maint. Program'">
                                            <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                                <span class="text-hidden-one-row">{{ option.description_one || '-' }}</span>
                                            </template>
                                            <template slot="gofixInput:dropdown:option" slot-scope="option">
                                                <div class="maintOption">
                                                    <span>{{ option.description_one || '-' }}</span>
                                                </div>
                                            </template>
                                        </gofix-form-dropdown>
                                    </b-col>
                                    <b-col md="9" class="text-right">
                                        <gofix-button 
                                            class="mr-2"
                                            :disabled="loading.maintenance"
                                            label="Mass Import Monthly Jobs"
                                            @click="openImportSchedule" >
                                        </gofix-button>
                                        <gofix-button 
                                            label="Print Calendar"
                                            @click="printCalendar" >
                                        </gofix-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </gofix-card>
                    <gofix-card classContent="mt-20" :class="['position-relative', {'run-loading': loadingEvent}]">
                        <FullCalendar
                            ref="fullCalendar"
                            :options='config'
                        >
                            <template v-slot:eventContent='arg'>
                                <template v-if="arg.event.extendedProps.equipment && arg.event.extendedProps.equipment.custom_fields_web && arg.event.extendedProps.equipment.custom_fields_web.length && arg.event.extendedProps.equipment.custom_fields_web[0].value">
                                    <div v-b-tooltip.hover :title="`Lift ${arg.event.extendedProps.equipment.custom_fields_web[0].value} - ${arg.event.title}`"><i>Lift {{ arg.event.extendedProps.equipment.custom_fields_web[0].value }} - {{ arg.event.title }}</i></div>
                                </template>
                                <div v-else v-b-tooltip.hover :title="arg.event.title"><i>{{ arg.event.title }}</i></div>
                            </template>
                            <template v-slot:dayCellContent="{ date }">
                                <div class="position-relative">
                                    <span>{{ date.getDate() }}</span>
                                    <b-button class="btnAddEvent" @click="handleDateSelect(date)"><img src="img/enabledBtn.png" alt="" /></b-button>
                                </div>
                            </template>
                        </FullCalendar>
                    </gofix-card>
        		</b-col>
        	</b-row>
        </div>

        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Equipment Maintenance Schedule" hide-footer :centered="true" v-model="modal.open" @close="() => {
            this.modal.data.maintenance = null;
        }">
            <b-form class="pb-20">
                <gofix-form-dropdown
                    label="Maintenance Program"
                    vLabel="description_one"
                    :filterable="false"
                    :append-to-body="true"
                    :options="options.popupMaintPrograms"
                    v-model="modal.data.maintenance"
                    placeholder=" "
                    @search="searchMaintProgram">
                    <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                        <span class="text-hidden-one-row">{{ option.description_one || '-' }}</span>
                    </template>
                    <template slot="gofixInput:dropdown:option" slot-scope="option">
                        <div class="maintOption">
                            <span>{{ option.description_one || '-' }}</span>
                        </div>
                    </template>
                </gofix-form-dropdown>
                <!--   -->
                <gofix-form-dropdown
                    label="Equipment Tag(s)"
                    class-label="text-transform-none"
                    :class="[{'run-loading small-loading': loading.equipment} ]"
                    :filterable="false"
                    :append-to-body="true"
                    v-model="modal.data.equipment_list"
                    :options="options.equipments"
                    vLabel="tag_name"
                    :multiple="true"
                    @search="searchEquipment">
                    <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                        <template v-if="option.lift_name">
                            {{ option.lift_name ? `Lift ${option.lift_name}` : '' }}{{ option.location_name ? ` - ${option.location_name}` : '' }}
                        </template>
                        <template v-else>
                            {{ option.location_name ? `${option.location_name}` : '' }}
                        </template>
                    </template>
                    <template slot="gofixInput:dropdown:option" slot-scope="option">
                        <template v-if="option.lift_name">
                            {{ option.lift_name ? `Lift ${option.lift_name}` : '' }}{{ option.location_name ? ` - ${option.location_name}` : '' }}
                        </template>
                        <template v-else>
                            {{ option.location_name ? `${option.location_name}` : '' }}
                        </template>
                    </template>
                </gofix-form-dropdown>
                <gofix-form-input-date
                    v-model="modal.data.date"
                    label="Date">
                </gofix-form-input-date>
                <b-form-checkbox v-model="modal.data.is_create_individual" class="checkbox-main-allow"><span class="ml-2">Create individual schedule for each equipment</span></b-form-checkbox>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="checkScheduledJob" :disabled="modal.loading" :loading="modal.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modal.checkSchedule.open">
            <div v-if="is_same_date == false" class="center pb-4 pl-2 pr-2">These equipment already had<br><strong>a schedule</strong></div>
            <div v-if="is_same_date == true" class="center pb-4 pl-2 pr-2">There is already a current <b>Due or Stated</b> job for the same Equipment with the same <b>Planned Date</b></div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modal.checkSchedule.open = false">Cancel</b-button>
                <b-button v-if="is_same_date == false" class="custom-btn" :disabled="modal.loading"  @click="overrideAssetManagement">
                    <b-spinner small type="grow" v-if="modal.loading"></b-spinner>Override
                </b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" title="Reschedule" id="modal-Reschedule" hide-footer :centered="true" v-model="modal.rescheduled.open">
            <b-form>
                <b-form-group>
                    <gofix-text-field label="Start Date:" oneline>
                        {{ this.modal.data.date | formatDatebyMoment("YYYY-MM-DD", $formatDateLift) }}
                    </gofix-text-field>
                </b-form-group>
                <b-form-group class="mb-0">
                    <gofix-form-input label="Reason" :required="true" v-model="modal.rescheduled.reason_rescheduled"></gofix-form-input>
                </b-form-group>
                <b-button-group class="d-block text-right">
                    <gofix-button label="RESCHEDULE" @click="reScheduledClick" :loading="modal.rescheduled.loading" noBorder></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
        <!--  -->
        <b-modal :no-close-on-backdrop="true" title="" id="modal-Errors" hide-footer hide-header :centered="true" v-model="modal.errors.open">
            <div>
               <p>Mass schedule cannot proceed due to existing expired/started jobs:</p>
                <ul>
                    <li v-for="(item, index) in modal.errors.list">
                        {{ item.equipment_name }} have (1) expired job
                    </li>
                </ul>
                <p>Kindly reschedule the expired jobs or complete the started jobs for the respective equipment.</p>
                <p class="text-center mb-0"><gofix-button label="Close" @click="modal.errors.open = false" noBorder></gofix-button></p>
            </div>
        </b-modal>
        <!--  -->
        <b-modal :no-close-on-backdrop="true" id="modal-Import" title="import file" hide-footer v-model="modal.importSchedule.open">
            <b-form>
                <gofix-form-dropdown
                    label="Maintenance Program"
                    vLabel="description_one"
                    :filterable="false"
                    :append-to-body="true"
                    :options="options.popupMaintPrograms"
                    v-model="modal.importSchedule.data.maintenance"
                    placeholder=" "
                    @search="searchMaintProgram">
                    <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                        <span class="text-hidden-one-row">{{ option.description_one || '-' }}</span>
                    </template>
                    <template slot="gofixInput:dropdown:option" slot-scope="option">
                        <div class="maintOption">
                            <span>{{ option.description_one || '-' }}</span>
                        </div>
                    </template>
                </gofix-form-dropdown>
                <b-form-group>
                    <b-form-file placeholder="Click Browse to upload file" :state="modal.importSchedule.file ? false : true" ref="file-input-schedule" accept=".csv" v-model="modal.importSchedule.file" >
                    <template slot="file-name" slot-scope="{ names }">
                        <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
                    </template>
                    </b-form-file>
                </b-form-group>

                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="importSchduledJobs" :loading="modal.importSchedule.loading"  noBorder></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { filters } from '@/_filterVar.js'
const simulateAsyncOperation = fn => {
    setTimeout(fn, 500);
};

import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import Printd from 'printd'
const d = new Printd()

export default {
    name: 'lift-inspection-calendar',
    components: {
        FullCalendar
    },
    data() {
        return{
            filters: {
                maintenance: null,
                start: null,
                end: null
            },
            options: {
                maints: [],
                tree_equipment_group: [],
                popupMaintPrograms: [],
                equipments: [],
            },
            loading: {
                equipment: false,
                maintenance: false
            },
            modal:{
                open: false,
                loading: false,
                ids: [],
                equipments:[],
                equipment_ids: [],
                data: {
                    property: null,
                    maintenance_id: null,
                    client_contract_id: null,
                    date: null,
                    equipment_list: [],
                    maintenance: null,
                    is_create_individual: false,
                },
                checkSchedule: {
                    open: false,
                },
                rescheduled: {
                    open: false,
                    loading: false,
                    ids: [],
                    reason_rescheduled: null,
                },
                errors: {
                    open: false,
                    list: []
                },
                importSchedule:{
                    open:false,
                    loading: false,
                    file:null,
                    data: {
                        maintenance: null,
                    }
                },
            },
            pagesEquipment: {
                isCMS: '1',
                limit: 100,
                page: 1,
                totalPage: 0,
                filter: JSON.parse(JSON.stringify(filters['equipment']))
            },
            timer: {
                modal: null
            },
            is_same_date: false
        }
    },
    computed: {
        ...mapGetters({
            events: "EquipmentV2Controller/liftInspectionEvents",
            loadingEvent: "EquipmentV2Controller/loadingEvent"
        }),
        config () {
            return {
                ...this.configOptions,
                ...this.eventHandlers
            }
        },
        configOptions () {
            return {
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    interactionPlugin // needed for dateClick
                ],
                headerToolbar: {
                    left: 'prev,next today',
                    center: 'title',
                    right: ''
                },
                initialView: 'dayGridMonth',
                events: this.events,
                editable: false,
                selectable: false,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                height: 1810,
            }
        },
        eventHandlers () {
            return {
                eventClick: this.handleEventClick,
                eventsSet: this.handleEvents,
                datesSet: this.handleDatesSet,
            }
        }
    },
    watch: {
        ClientContractID: function(val, old) {
            if(old && val && old.id != val.id) this.getCalendarView()
            if(val && val.id) {
                this.getMaintProgram(null, false, true)
                this.filters.maintenance = {
                    id: 'All',
                    description_one: 'All'
                };
            } else {
                this.options.maints = this.options.tree_equipment_group = []
                this.$store.commit('EquipmentV2Controller/setLiftInspectionEvents', [])
            }
        },
        "modal.data.maintenance": function(val, old) {
            this.options.equipments = this.modal.data.equipment_list = []
            if(val) {
                this.getEquipment();
            }
        },
        "filters.maintenance": function(val, old) {
            if(old && val && old.id != val.id) this.getCalendarView()
            if(val && val.id != 'All')
                this.getEquipment()
        }
    },
    created() {
        if(this.ClientContractID && this.ClientContractID.id) {
            this.getMaintProgram(null, false, true)
            this.filters.maintenance = {
                id: 'All',
                description_one: 'All'
            };
        }
    },
    methods: {
        async searchMaintProgram(search, loading) {
            loading(true)
            this.options.maints = []
            if (this.timer.maint) {
                clearTimeout(this.timer.maint);
                this.timer.maint = null;
            }
            this.timer.maint = setTimeout(async () => {
                try {

                    let is_popup = false;
                    if(this.modal.open)
                        is_popup = true;

                    await this.getMaintProgram(search, is_popup);
                    await loading(false)
                } catch(e) {
                    loading(false)
                }
            }, 500);
        },
        async getMaintProgram(search = null, is_popup = false, is_load_first = false) {
            let filters = {
                search:             search,
                contract_term_id:   this.ClientContractID.contract_term_id,
                is_maintenance:     true,
                is_master:          false,
                recurring_mode_one_and_five_year: true
            }

            if(!is_popup) this.loading.maintenance = true

            await this.$store.dispatch("v2SorController/getItems", {
                isCMS: false,
                page: 1,
                limit: 100,
                group_id: 0,
                filter: filters
            })
            .then(response => {
                this.loading.maintenance = false
                if(!is_popup) {
                    this.options.maints = [{
                        id: 'All',
                        description_one: 'All'
                    }].concat(response.items);
                    if(is_load_first) this.options.popupMaintPrograms = response.items;
                } else {
                    this.options.popupMaintPrograms = response.items;
                }
            })
            .catch(err => {
                this.loading.maintenance = false
                this.options.maints = [];
            })
        },
        async searchEquipment(search, loading) {
            loading(true)
            this.equipments = []
            if (this.timer.equipment) {
                clearTimeout(this.timer.equipment);
                this.timer.equipment = null;
            }
            this.timer.equipment = setTimeout(async () => {
                try {
                    await this.getEquipment("", search);
                    await loading(false)
                } catch(e) {
                    loading(false)
                }
            }, 500);
        },
        async getEquipment(property_id = "", search = "") {
            if(this.ClientContractID && this.ClientContractID.id) {
                this.loading.equipment = true;
                this.pagesEquipment.filter['equipment.is_active'] = {  type: 'boolean', value: true }
                this.pagesEquipment.filter.tag_name.value = search;
                this.pagesEquipment.filter.contract_id.value = this.ClientContractID.id;

                if(this.modal.data.maintenance) {
                    this.pagesEquipment.maintenance_id = this.modal.data.maintenance.id;
                    this.pagesEquipment.maintenance_property_id = this.modal.data.maintenance.property_id;
                    this.pagesEquipment.maintenance_equipment_group_id = this.modal.data.maintenance.equipment_group_id;
                    this.pagesEquipment.recurring_mode = this.modal.data.maintenance.get_sor_recurring_mode ? this.modal.data.maintenance.get_sor_recurring_mode.recurring_mode : null;
                } else if(this.filters.maintenance) {
                    this.pagesEquipment.maintenance_id = this.filters.maintenance.id;
                    this.pagesEquipment.maintenance_property_id = this.filters.maintenance.property_id;
                    this.pagesEquipment.maintenance_equipment_group_id = this.filters.maintenance.equipment_group_id;
                    this.pagesEquipment.recurring_mode = this.filters.maintenance.get_sor_recurring_mode ? this.filters.maintenance.get_sor_recurring_mode.recurring_mode : true;
                }

                await this.$store.dispatch("EquipmentV2Controller/getEquipmentsOfLiftInspectionCalendar", this.pagesEquipment)
                .then(response => {
                    this.loading.equipment = false;
                    this.options.equipments = response.data.data.items;
                    this.loading.equipment = false;
                })
                .catch(err => {
                    this.loading.equipment = false;
                    console.log(err)
                })
            }
        },

        /* --- Schedule --- */
        checkSchedule() {
            if(!this.modal.data.maintenance || !this.modal.data.equipment_list.length) return false;
        },
        checkScheduledJob() {
            if(this.modal.loading) return 
            if(!this.modal.data.equipment_list.length) {
                return this.$alertNotification("Equipment tag(s) is required", "danger");
            }

            if(!this.modal.data.maintenance) {
                return this.$alertNotification("Maintenance program is required", "danger");
            }

            if(!this.modal.data.date) {
                return this.$alertNotification("Date is required", "danger");
            }

            if(moment(this.modal.data.date).isBefore(moment(), 'day')) {
                return this.$alertNotification("The date must be greater than or equal to the current date.", "danger");
            }

            if(this.checkSchedule()) {
                return this.$alertNotification("Scheduling is not possible because some equipment tag have equipment groups and properties that are not part of the maintenance program you choose.", "danger");
            }

            let request = {
                equipment_list: this.modal.data.equipment_list,
                maintenance_id: this.modal.data.maintenance.id,
                planned_date:   moment(this.modal.data.date).format('YYYY-MM-DD')
            }

            this.modal.loading = true;
            if (this.timer.modal) {
                clearTimeout(this.timer.modal);
                this.timer.modal = null;
            }
            
            this.modal.errors.list = []
            this.is_same_date = false

            this.timer.modal = setTimeout(async () => {

                this.$store.dispatch("EquipmentV2Controller/checkExpiredJobsRescheduling", request)
                .then(async response => {
                    
                    let result = response.data.data;
                    if ( result && result.length > 0 ) {
                        if ( this.modal.data.equipment_list.length > 1 ) {

                            this.modal.loading = false
                            this.modal.errors.list = result
                            this.modal.errors.open = true
                            
                            return;
                        }

                        let id_ = (result[0] && result[0].id) ? result[0].id : null;
                        this.checkScheduledAndReschedule(request, id_);
                    } else {
                        this.checkScheduledAndReschedule(request);
                    }
                })
                .catch(err => {
                    this.modal.loading = false;
                    console.log(err);
                })
            }, 200);
        },
        checkScheduledAndReschedule(request, rescheduled_id = null) {
            if ( this.modal.data.equipment_list.length == 1 ) request.check_planned_date = 1;
            this.$store.dispatch("EquipmentV2Controller/checkScheduledJob", request)
            .then(async response => {
                let result = response.data.data;

                if ( result.is_same_date ) {
                    this.is_same_date = true
                }
                
                if(!result.existing) {
                    if(rescheduled_id) {
                        this.modal.rescheduled.ids = [rescheduled_id];
                        this.modal.loading = false
                        this.modal.open = false
                        this.modal.rescheduled.open = true
                        return
                    }
                    this.createAssetManagement();
                    return;
                }

                this.modal.loading = false;
                this.modal.checkSchedule.open = true;
            })
            .catch(err => {
                this.modal.loading = false;
                console.log(err);
            })
        },
        async reScheduledClick() {

            if(!this.modal.rescheduled.ids) {
                return this.$alertNotification('Job is required', 'danger');
            }

            if(!this.modal.data.date) {
                return this.$alertNotification('Start Date is required', 'danger');
            }

            if(!this.modal.rescheduled.reason_rescheduled) {
                return this.$alertNotification('Reason is required', 'danger');
            }

            this.modal.rescheduled.loading = true

            let dataRes = {
                ids: this.modal.rescheduled.ids,
                start_date: moment(this.modal.data.date).format('YYYY-MM-DD'),
                reason_rescheduled: this.modal.rescheduled.reason_rescheduled
            };

            await this.$store
            .dispatch("JobController/reScheduledRunsheet", dataRes)
            .then((result) => {
                this.modal.rescheduled.open = false
                this.modal.rescheduled.loading = false
                this.modal.rescheduled.ids = []
                this.modal.data.date = null
                this.modal.rescheduled.reason_rescheduled = null
                this.getCalendarView()
                this.$alertNotification('Reschedule success!');
            })
            .catch((err) => {
                this.modal.rescheduled.open = false
                this.modal.rescheduled.loading = false
                this.modal.rescheduled.ids = []
                this.modal.data.date = null
                this.modal.rescheduled.reason_rescheduled = null
                if(err.response.data.error.message.error){
                    return this.$alertNotification(err.response.data.error.message.error, 'danger');
                }
            });
        },
        overrideAssetManagement() {
            if(this.modal.loading) return 
            this.modal.loading = true;
            if (this.timer.modal) {
                clearTimeout(this.timer.modal);
                this.timer.modal = null;
            }
            this.timer.modal = setTimeout(async () => {
                this.createAssetManagement();
            }, 200);
        },
        createAssetManagement() {
            this.modal.checkSchedule.open = false;
            this.modal.data.maintenance_id = this.modal.data.maintenance.id;
            let objeClone = JSON.parse(JSON.stringify(this.modal.data));
            objeClone.start_date = moment(objeClone.date).format('YYYY-MM-DD');
            objeClone.end_date = moment(objeClone.date).format('YYYY-MM-DD');
            objeClone.equipment_list = JSON.stringify(
                objeClone.equipment_list.map(item => {
                    return {
                            id: item.id,
                            name: item.tag_name
                        };
                    })
                );
            
            this.$store.dispatch("EquipmentV2Controller/createAssetManagement", objeClone)
            .then(response => {
                this.modal.loading = false;
                this.modal.open = false;
                this.getCalendarView()
                this.$alertNotification(this.$notificationV2('adding', 'asset_management'));
            })
            .catch(err => {
                this.modal.loading = false;
                if(err.response && err.response.data && err.response.data.error && err.response.data.error.message) {
                    this.$alertNotification(err.response.data.error.message, "warning");
                }
            })
        },

        /* --- Calendar --- */
        getCalendarView() {
            this.$store.dispatch("EquipmentV2Controller/getCalendarView", {
                filter: {
                    client_contract_id: this.ClientContractID.id,
                    start: this.filters.start,
                    end: this.filters.end,
                    maintenance_id: this.filters.maintenance && this.filters.maintenance.id ? this.filters.maintenance.id : null,
                    // location_id: this.filters.maintenance && this.filters.maintenance.property_id ? this.filters.maintenance.property_id : null
                }
            })
        },
        handleWeekendsToggle() {
            this.calendarOptions.weekends = !this.calendarOptions.weekends // update a property
        },

        handleDateSelect(date) {
            this.modal.data.maintenance = this.filters.maintenance && this.filters.maintenance.id != 'All' ? this.filters.maintenance : null;

            //check: allow schedule
            if(this.checkSchedule()) {
                return this.$alertNotification("Scheduling is not possible because some rows have equipment groups and properties that are not part of the maintenance program you choose.", "danger");
            }

            this.modal.data.date = date;
            this.modal.data.is_create_individual = false;
            this.modal.data.equipment_list = []
            this.modal.data.client_contract_id = this.ClientContractID && this.ClientContractID.id ? this.ClientContractID.id : null;
            this.modal.loading = false;
            this.modal.rescheduled.reason_rescheduled = null
            this.modal.open = true;
        },

        handleEventClick(clickInfo) {
            let route = this.$router.resolve({ path: `/v2/job-list/${clickInfo.event.id}` })
            window.open(route.href, '_blank');
        },
        handleDatesSet(info) {
            this.filters.start = moment(info.start).format('YYYY-MM-DD')
            this.filters.end = moment(info.end).format('YYYY-MM-DD')
            if(this.filters.start && this.filters.end) {
                this.getCalendarView()
            }
        },
        printCalendar() {
            const collection = document.getElementsByClassName("fc-media-screen");
            const cssText = `  @page {size: A3 landscape;margin: 0mm 0mm 0mm 0mm;}table {border-collapse: collapse;border-spacing: 0;}table th, table td {padding: 0;} .fc-media-screen {height: auto !important;} .fc-toolbar-chunk:nth-child(1), .fc-toolbar-chunk:nth-child(3), .fc-daygrid-day-bottom, .btnAddEvent {display: none;}.fc-toolbar-chunk:nth-child(2) {text-align: center;font-size: 20px;}.fc-toolbar-chunk:nth-child(2) h2 {margin: 20px 10px 10px;}.fc-dayGridMonth-view {font-size: 13px;line-height: 15px;font-family: Helvertica;}.fc-col-header .fc-col-header-cell, .fc-daygrid-body .fc-day {width: calc(100% / 7);border: 1px solid #ccc;}.fc-col-header .fc-col-header-cell {padding: 5px;}.fc-daygrid-body .fc-day {vertical-align: top;}.fc-daygrid-body .fc-daygrid-day-frame {min-height: 120px;padding: 5px;}.fc-scrollgrid, .fc-scroller-harness .fc-col-header, .fc-daygrid-body {width: 100% !important;}.fc-scrollgrid-sync-table {width: 100% !important;height: auto !important;}.fc-daygrid-day-frame .fc-daygrid-day-top {text-align: right;}.fc-daygrid-day-frame .fc-daygrid-event-harness {visibility: inherit !important;}.fc-daygrid-day-frame .fc-daygrid-event-harness {background-color: #3788d8;border-radius: 2px;padding: 2px 5px;margin-bottom: 3px;font-size: 10px;} `
            d.print(collection[0], [cssText])
        },
        openImportSchedule() {
            this.modal.importSchedule.open = true;
            this.modal.importSchedule.file = null;
            this.modal.importSchedule.data.maintenance = null;
            this.modal.importSchedule.loading = false;
        },
        async importSchduledJobs(){
            if(this.modal.importSchedule.loading) return ;
            if (!this.modal.importSchedule.file) {
                return this.$alertNotification("Please choose file to import", "danger");
            }
            if (!this.modal.importSchedule.data.maintenance) {
                return this.$alertNotification("Please select maintenance program to import", "danger");
            }

            this.modal.importSchedule.loading = true;
            await this.$store.dispatch(`AssetManagementController/importSchduledJobs`, {
                client_contract_id: this.ClientContractID.id,
                file_import: this.modal.importSchedule.file,
                maintenance_id: this.modal.importSchedule.data.maintenance.id,
            })
                .then(response => {
                    if(response.data.error) {
                        this.modal.importSchedule.loading = false;
                        return this.$alertNotification(response.data.message, "danger");
                    }
                    let variant = 'success';
                    let msg = this.$notificationV2('importing', 'schedule_job');
                    let result = response.data.data;
                    if(result.data && result.data.count && result.data.count.failed ) {
                        variant = 'danger';
                        msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                    }
                    this.$alertNotification(msg, variant);
                    this.modal.importSchedule.open = false;
                    this.modal.importSchedule.loading = false;
                    this.getCalendarView();
                })
                .catch(err => {
                    this.modal.importSchedule.loading = false;
                    let msg = "Can't import data!";
                    if( err.response.data.error
                        && err.response.data.error.message
                    ) {
                        msg = err.response.data.error.message;
                    }

                    return this.$alertNotification(msg, "danger");
                });
        },
    }
}
</script>
<style lang="scss">
    .fc-more-popover-misc {
        display: none !important;
    }
    .fc-daygrid-day-top {
        position: relative;
        .fc-daygrid-day-number {
            flex: 1;
            text-align: right;
        }
    }
    .btnAddEvent {
        background: transparent;
        border: none;
        position: absolute;
        top: -5px;
        left: 0;
        padding: 0;
        img {
            width: 32px;
        }
        &:hover {
            background-color: transparent !important;
            border-color: transparent !important;
            box-shadow: none !important;
            outline: none;
        }
        &:focus {
            background-color: transparent !important;
            border-color: transparent !important;
            outline: none;
            box-shadow: none !important;
        }
        &:active {
            background-color: transparent !important;
            border-color: transparent !important;
            outline: none;
            box-shadow: none !important;
        }
    }
    .fc-header-toolbar {
        .fc-toolbar-chunk:last-child {
            flex-basis: 8%;
        }
    }
    .fc {
        table {
            font-size: 13px;
        }
    }
</style>
